// src/store/modules/device.js
import MobileDetect from 'mobile-detect';

const state = {
    isMobile: false,
};

const mutations = {
    SET_IS_MOBILE(state, payload) {
        state.isMobile = payload;
    },
};

const actions = {
    autoDetectByUserAgent({ commit }) {
        const md = new MobileDetect(window.navigator.userAgent);
        const isMobile = md.mobile() !== null;
        commit('SET_IS_MOBILE', isMobile);
    },
    updateByWindowSize({ commit }) {
        const isMobile = window.innerWidth <= 768;
        commit('SET_IS_MOBILE', isMobile);
    },
};

const getters = {
    isMobile: state => state.isMobile,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};